// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--1Ljc5","textContainer":"styles-module--textContainer--3WpFL","link":"styles-module--link--2IMsl","image":"styles-module--image--3_g2O"};